import { useQuery } from '@apollo/client'
import { Navigate } from 'react-router'

import { LinearProgress } from '../../components'
import { queries } from '../../graphql'

export function FundList() {
  const { data: { me: { funds = [] } = {} } = {}, loading } = useQuery(queries.funds.myFunds)
  if (loading) {
    return <LinearProgress />
  }
  const openFunds = funds.filter((f) => !f.closed)
  const donorFund = openFunds.find((f) => !f.name?.startsWith('charity-'))
  if (donorFund) {
    return <Navigate to={`${donorFund.id}`} replace />
  }
  return null
}
